import * as App from '../../app';
import * as SDK from '../../lib/sdk';
export function applyAdSettings(game) {
    var settings = App.settings.get();
    SDK.Ad.setNativeInterval(settings.nativeInterval);
    SDK.Ad.setRewardedInterval(settings.rewardedInterval);
    SDK.Ad.setNativeTimeout(settings.nativeTimeout);
    if (FOR_VK)
        SDK.Ad.setUseWaterfall(settings.vkUseWaterfall);
    SDK.Ad.setFreeHoursAfterPurchase(settings.adFreeHoursAfterPurchase);
    SDK.Ad.setFreeHoursForNewUsers(settings.adFreeHoursForNewUsers);
    SDK.Ad.setNativeLimit(settings.nativeLimit);
    game.toggleCoupBtn(settings.useCoupBtn);
}
